/* eslint-disable no-param-reassign */

import axiosConfig from './axiosUtils';
// import requestStatus from './requestStatus';
import config from './config';

import requestStatus from './requestStatus';

import requestCode from './requestStatusCode';

const install = (Vue) => {
  Vue.prototype.$vue = Vue;
  // eventBus
  Vue.prototype.$bus = new Vue();
  // 参数配置
  Vue.prototype.$config = config;
  // 网络请求
  Vue.prototype.$http = axiosConfig;
  // 请求状态编号
  Vue.prototype.$requestCode = requestCode;
  // 请求状态
  Vue.prototype.$requestStatus = requestStatus;

  // Vue.prototype.$requestStatus = requestStatus;
};
export default install;



// WEBPACK FOOTER //
// ./src/lib/common.js